import {Button, Card, CardContent, CardHeader, makeStyles, Theme} from '@material-ui/core';
import React, {useState} from 'react';
import {GroupMember, RoomParty, RoomPartyMember} from '../../../graphql/groups.datatypes';
import RoomPartyMemberEditModal from '../RoomPartyMemberEditModal/RoomPartyMemberEditModal';
import {GroupMemberListContent} from '../../Groups/GroupMemberList/GroupMemberList';
import SplitRoomPartyModal from '../SplitRoomPartyModal';
import RoomPartyMemberChangeRoomModal from '../RoomPartyMemberChangeRoomModal/RoomPartyMemberChangeRoomModal';

const useStyles = makeStyles((theme: Theme) => ({
    container: {
        marginTop: theme.spacing(3),
        width: '100%',
        marginBottom: theme.spacing(2),
    },
    linkButton: {
        marginRight: theme.spacing(1),
    },

}));

export const getBlankRoomPartyMember = (roomParty: RoomParty) => {
    return {
        __typename: 'RoomPartyMember',
        id: -1,
        room_party_id: roomParty.id,
        group_member_id: -1,
        billing_party_id: -1,
        primary_occupant: roomParty.members!.length === 0,
        guest_number: roomParty.members!.length + 1,
        start_date: roomParty.start_date,
        end_date: roomParty.end_date,

        cost: 0,
        roomParty,
        options: [],
    }
};

export const RoomPartyMembersList = (props: { roomParty: RoomParty, isAdmin: boolean, canEdit: boolean, groupRef?: string }) => {
    const classes = useStyles();
    const {roomParty, isAdmin, canEdit, groupRef} = props;
    const isNewParty = roomParty.id === -1;
    const [selectedRoomGuest, setSelectedRoomGuest] = useState<RoomPartyMember | null>(null);
    const [selectedModal, setSelectedModal] = useState('');

    //Split modal functions
    const [openSplitPopup, setOpenSplitPopup] = useState(false);
    const handleOpenSplitPopup = () => {
        setOpenSplitPopup(true);
    };
    const handleCloseSplitPopup = () => {
        setOpenSplitPopup(false);
    };

    if (!roomParty.booking) return <div>loading...</div>

    return (
        <React.Fragment>
            {!isNewParty && (
                <Card className={classes.container}>
                    <CardHeader title="Room Party Guests" action={[
                        isAdmin && (<Button key={1}
                                            variant="contained"
                                            className={classes.linkButton}
                                            onClick={() => {
                                                setSelectedRoomGuest(getBlankRoomPartyMember(roomParty))
                                                setSelectedModal('details')
                                            }}
                        >Add Room Guest</Button>),
                        isAdmin && !isNewParty && <Button key={2} className={classes.linkButton}
                                                          onClick={handleOpenSplitPopup} variant="contained">Split
                            Room</Button>,
                    ]}/>
                    <CardContent>
                        <GroupMemberListContent
                            roomPartyId={roomParty.id}
                            action={isAdmin ? ((groupMember) => setSelectedRoomGuest(roomParty.members!.find(member => member.groupMember!.id === groupMember.id)!)) : undefined}
                            setModal={isAdmin ? ((modelSelection: string) => setSelectedModal(modelSelection)) : undefined}
                            actionTitle="Room Guest Details"
                            isAdmin={isAdmin} canEdit={canEdit} groupRef={groupRef}
                        />
                    </CardContent>
                </Card>
            )}

            {selectedRoomGuest && selectedModal === 'details' && (
                <RoomPartyMemberEditModal
                    onClose={() => {
                        setSelectedRoomGuest(null)
                        setSelectedModal('')
                    }}
                    open={true}
                    roomParty={roomParty}
                    roomPartyMember={selectedRoomGuest}
                    setSelectedRoomGuest={setSelectedRoomGuest}
                    setSelectedModal={setSelectedModal}
                />
            )}

            {selectedRoomGuest && selectedModal === 'change_room' && (
                <RoomPartyMemberChangeRoomModal
                    onClose={
                        () => {
                            setSelectedRoomGuest(null)
                            setSelectedModal('')
                        }
                    }
                    open={true}
                    roomParty={roomParty}
                    roomPartyMember={selectedRoomGuest}
                    setSelectedRoomGuest={setSelectedRoomGuest}
                    setSelectedModal={setSelectedModal}
                />
            )}

            {openSplitPopup && (
                <SplitRoomPartyModal onClose={handleCloseSplitPopup} open={true} roomParty={roomParty}/>
            )}
        </React.Fragment>
    );
};

export default RoomPartyMembersList;
